import StorageService from '../services/storage/storage.service'
import { useAppSelector } from '../store/storeRequests'
import StoreSelectors from '../utils/constants/StoreSelectors.constants'

/**
 * This hook will identify whether an user logged in or not
 *  returns true or false values
 */

const useAuth = () => {

    const REQUIRED_USER_PROPS = ['email', 'user_id']

    const userState = useAppSelector(StoreSelectors.USER_STATE)
    const { user } = StorageService.getFromStorage(['user'])

    let currentuser = -1

    if (typeof user !== 'object' || typeof user['user_id'] === 'undefined') {
        return 0
    } else if (user['token']?.length === 0 || user['user_id']?.length === 0) {
        return 0
    }
    

    for (let index in REQUIRED_USER_PROPS){
        if (userState?.user[REQUIRED_USER_PROPS[index]]?.length === 0) {
            currentuser = 2
            break
        }
    }

    return currentuser === -1 ? 1 : currentuser

}

export default useAuth